import styled from 'styled-components';

/**
 * MainTable heads are nowrap by default — long money labels
 * ("SCRATCHCARDS REVENUE") collide. This wrapper lets header labels wrap
 * across lines with a smaller font, the EnrollmentInvoices treatment.
 */
const WrappedHeadsTable = styled.div`
	width: 100%;

	thead th {
		white-space: normal;
		padding: 0 0.5rem;
		font-size: 0.8rem;
		line-height: 1.25;
	}
`;

export default WrappedHeadsTable;
